import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Turbo frame of paginated reviews (training page, trainer profile): bring the list back into view.
  scrollIntoView () {
    const elementPosition = this.element.getBoundingClientRect().top + window.scrollY - 80
    window.scrollTo({ top: elementPosition, behavior: "smooth" })
  }
}
